<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row>
        <b-col md="5">
          <b-card-group>
            <b-card no-body class="p-4">
              <img :src="enac ? 'img/logo_enac.png' : 'img/logo-small.png'" alt="E.C.Fo.P. Logo" class="logo" />
              <b-card-body>
                <b-form>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-lock"></i>&nbsp;
                        Password attuale
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      type="password"
                      v-model="oldPassword"
                      class="form-control"
                      placeholder="Password attuale"
                      autocomplete="Password attuale"
                    />
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-lock"></i>&nbsp;
                        Nuova Password
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      type="password"
                      v-model="pw1"
                      class="form-control"
                      placeholder="Password"
                      autocomplete="Password"
                    />
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-lock"></i>&nbsp;
                        Ripeti Nuova Password
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      type="password"
                      v-model="pw2"
                      class="form-control"
                      placeholder="Password"
                      autocomplete="Password"
                    />
                  </b-input-group>
                  <br />
                  <b-button
                    v-if="canSubmit"
                    :disabled="!canSubmit"
                    type="submit"
                    variant="primary"
                    class="px-12"
                    @click="handleSubmit"
                  >Conferma</b-button>
                  <br><br>
                  <b-button
                    type="submit"
                    variant="primary"
                    class="px-12"
                    @click="handleAnnulla"
                  >Annulla</b-button>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
        <b-col md="7">
          <div :class="enac ? 'bgimageenac' : 'bgimage'"></div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
var CryptoJS = require("crypto-js");
import { API } from "@/api.js";

export default {
  name: "ChgPass",
  data() {
    return {
      pw0: "",
      pw1: "",
      pw2: "",
      oldPassword: "",
    };
  },
  created: async function() {
  },
  computed: {
    canSubmit(){
      // questo sotto serve solo ad attivare il listener sulle modifiche
      let dummy = this.oldPassword + this.pw1 + this.pw2
      var pw = localStorage.getItem("pw");
      let pwt = CryptoJS.AES.decrypt(pw, window.secret).toString(CryptoJS.enc.Utf8)
      let ok = this.oldPassword==pwt && this.pw1==this.pw2 && this.pw1!="" && this.oldPassword!=this.pw1
      console.log("?!?",this.oldPassword,pwt)
      return ok
    },
    enac() {
      return window.ENAC
    },
  },
  mixins: [window.myMixin],
  methods: {
    handleAnnulla() {
      this.$router.push("/");
    },
    handleSubmit(e) {
      var me = this;
      e.preventDefault();
      if (this.pw1.length > 0) {
        let url = window.baseurl + "/setPass";
        this.$http.post(url, {pw: this.pw1,})
            .then(async response => {
                localStorage.setItem("pw",CryptoJS.AES.encrypt(me.pw1, window.secret).toString());
                me.$router.push("/");
            })
          .catch(function(error) {
            console.error(error.response);
            sessionStorage.setItem(window.keyname, "null");
          });
      }
    }
  }
};
</script>
<style scoped>
img.logo {
  width: 128px;
  margin: auto;
}
div.bgimage {
  background-image: url("../../../public/img/login-bg.jpg");
  height: 100%;
  background-size: cover;
  background-position: top;
}
div.bgimageenac {
  background-image: url("../../../public/img/enacbg.jpg");
  height: 100%;
  background-size: cover;
  background-position: top;
}
div.input-group-text {
  width: 200px;
}
</style>
<style>
.custom-control-label {
  vertical-align: inherit;
}
</style>